module.exports = __webpack_public_path__ + "img/anaqueles_leches.fa03054d.png";